import { Component, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "onsip-phones-empty-data",
  templateUrl: "./phones-empty-data.component.html",
  styleUrls: ["./phones-empty-data.component.scss"],
  standalone: false
})
export class PhonesEmptyDataComponent {
  @Output() addNewPhone = new EventEmitter();
}
